import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceListLayer from "../components/InvoiceListLayer";
import { API_URL, LOCATION_ID } from "..";
import { Spinner } from "react-bootstrap";
import QuoteListLayer from "../components/QuoteListLayer";

const QuoteListPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState({
    totalInvoicesCount: 0,
    totalInvoiceAmountCount: 0,
    paidInvoiceCount: 0,
    paidInvoiceAmountCount: 0,
    overdueInvoiceCount: 0,
    overdueInvoiceAmountCount: 0,
  });

  const fetchInvoices = async () => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      window.location.href = "/sign-in";
    } else {
      let headersList = {
        Accept: "*/*",
        "Content-Type": "application/json",
      };
      const currentUser = JSON.parse(localStorage.getItem("user"));
      let url;
      if (currentUser?.roles?.role == "admin") {
        url = API_URL + `/api/invoice/get/quote?locationId=${LOCATION_ID}`;
      } else {
        url = API_URL + `/api/invoice/get/user/quote/${currentUser?.id}?locationId=${LOCATION_ID}`;
      }
      let response = await fetch(url, {
        method: "GET",
        headers: headersList,
      });
      const data = await response.json();
      setLoading(false);
      setData(data.invoices);
    }
  };
  useEffect(() => {
    fetchInvoices();
  }, [1]);
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}

        <Breadcrumb title="Quotes" />

        {loading === true ? (
          <div className="text-center mt-4">
            <Spinner />
          </div>
        ) : null}
        {/* InvoiceListLayer */}
        {data.length === 0 && loading === false ? (
          <p>No Quotes Found....</p>
        ) : null}
        {data.length == 0 ? null : <QuoteListLayer jobsData={data} />}
      </MasterLayout>
    </>
  );
};

export default QuoteListPage;
